import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getFromSettings, isAfterHours } from 'src/utils/helpers'

import NavBottom from './NavBottom'

import { openSidebar, closeSidebar, setCurrentlyOpenFeature } from 'src/modules/App/actions'
import { setAppActionsDisabledState } from 'src/modules/App/nonPersistentActions'

const mapStateToProps = state => {
  const afterHours = getFromSettings(state, 'afterHours')
  const timeZone = parseFloat(getFromSettings(state, 'timeZone', 0))
  return {
    user: state.user.user,
    chatUnreadCount: state.chat.unreadCount,
    isChatOnlyFeature: state.appReducer.isChatOnlyFeature,
    features: state.appReducer.features,
    chat: state.appReducer.chat,
    chatOptions: getFromSettings(state, 'chatOptions', {}),
    isAfterHours: isAfterHours(afterHours, timeZone),
    isChatEmpty: state.chat.isChatEmpty,
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
    brand: getFromSettings(state, 'brand', {}),
    pageBackground: state.appReducer.settings.brand.colors.backgroundColor,
  }
}

const mapDispatchToProps = {
  openSidebar,
  closeSidebar,
  setCurrentlyOpenFeature,
  setAppActionsDisabledState,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBottom))
